import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ImgWithTitle from "../../component/workspaceContainer/ImgWithTitle";
import { PrimaryButton } from "../../component/buttonComponent/ButtonComponent";
import "./ForgotPassword.css";
import FooterImage from "../../image/header.png";

const PasswordReset = ({ history }) => {
  const navigate = useNavigate();
  const userType = sessionStorage.getItem("resetUserType");
  const isParent = userType === "parent";

  const btnBack = (e) => {
    e.preventDefault();
    navigate("/login", { replace: true });
  };

  return (
    <div className="forgot-password-container-main">
      <div className="forgot-password-container">
        <div className="img-with-title-container">
          <ImgWithTitle
            titleText="Password reset"
            subText="Voilà! Your password has been successfully reset. Now let's try logging in again."
            icon="Success"
          />
        </div>
        <div
          className="forgot-password-reset-button"
          style={{ paddingTop: "1rem" }}
        >
          {!isParent && (
            <PrimaryButton label="Back to log in" onClickFunction={btnBack} />
          )}
        </div>
      </div>
      <div className="login-logo-footer">
        <div className="login-logo">
          <img
            loading="lazy"
            src={FooterImage}
            className="logo"
            alt="header-logo"
          />
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
